import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-call-for-workshops',
  templateUrl: './call-for-workshops.component.html',
  styleUrls: ['./call-for-workshops.component.css']
})
export class CallForWorkshopsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
